


























































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import PreviewEmailButton from '@/components/Admin/Layout/PreviewEmailButton.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component({
    components: {
        PreviewEmailButton,
    },
})
export default class FinalizePresentation extends Mixins(InputFieldMethods) {
    public assignedEmail: string = '';

    constructor() {
        super();
    }

    public loadPreviewEmailOverlay(templateId: any ) {
        const data = {
            templateId,
            presentationId: this.$store.getters['PresentationFlows/getCurrentEditPresentation'].id,
            assignedEmail: this.assignedEmail,
        };
        this.$store.dispatch(Actions.FETCH_TEMPLATE_RENDERER, data);
    }

    public reOpenOffer() {
        this.$store.dispatch(Actions.RE_OPEN_OFFER, this.$store.getters['PresentationFlows/getCurrentEditPresentation'].id);
    }

    public completeOffer() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.COMPLETE_OFFER, {
                    presentationId: this.$store.getters['PresentationFlows/getCurrentEditPresentation'].id,
                    assignedEmail: this.assignedEmail,
                });
            }
        });

    }

    public cancel() {
        this.$store.commit(Mutations.SET_FINALIZE_PRESENTATION_VISIBILITY, false);
    }
}
